type IsEmailAllowed = (
  email: string | null | undefined,
  allowedEmails: string | null | undefined,
) => boolean;

const isEmailAllowed: IsEmailAllowed = (email, allowedEmails) => {
  if (!email?.trim() || !allowedEmails?.trim()) {
    return false;
  }

  const normalizedEmail = normalizeEmail(email);
  return allowedEmails
    .split(",")
    .map(normalizeEmail)
    .filter(Boolean)
    .includes(normalizedEmail);
};

const normalizeEmail = (email: string): string => email.trim().toLowerCase();

export default isEmailAllowed;
